"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputColor = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const context_1 = require("../../styles/context");
const Input_1 = require("../Input");
const InputColor = (props) => {
    const styles = (0, context_1.useStyles)();
    const swatchSize = props.label ? 32 : 16;
    const rightElement = (React.createElement("div", { style: {
            width: 32,
            height: swatchSize,
            background: props.value || '#000000',
            padding: 0,
            margin: props.label ? '-18px -4px 0 0' : '-1px -4px 0 0',
            cursor: 'pointer',
            border: `3px solid ${styles.g(0.99, 0.9)}`,
            borderRadius: 2,
            boxShadow: `0px 1px 2px rgba(0,0,0,.2)`,
            position: 'relative',
            overflow: 'hidden',
            flexShrink: 0,
        } },
        React.createElement("input", { type: "color", value: props.value || '#000000', onChange: (e) => props.onChange?.(e.target.value), style: {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                padding: 0,
                margin: 0,
                border: 0,
                cursor: 'pointer',
                opacity: 0,
            } })));
    return React.createElement(Input_1.Input, { right: rightElement, ...props });
};
exports.InputColor = InputColor;
